/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Remove_SuccessInputs */

const en_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group has been removed.`)
};

const fr_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d'événements a été supprimé.`)
};

const de_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisgruppe wurde entfernt.`)
};

const it_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo di eventi è stato rimosso.`)
};

const ru_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий удалена.`)
};

const es_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha eliminado el grupo de eventos.`)
};

const zh_cn2_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组已被移除。`)
};

const ja_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループが削除されました。`)
};

const hi_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप को हटा दिया गया है।`)
};

const pt_pt2_event_group_options_remove_success = /** @type {(inputs: Event_Group_Options_Remove_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos foi removido.`)
};

/**
* | output |
* | --- |
* | "Event group has been removed." |
*
* @param {Event_Group_Options_Remove_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_remove_success = /** @type {((inputs?: Event_Group_Options_Remove_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Remove_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_remove_success(inputs)
	if (locale === "de") return de_event_group_options_remove_success(inputs)
	if (locale === "it") return it_event_group_options_remove_success(inputs)
	if (locale === "ru") return ru_event_group_options_remove_success(inputs)
	if (locale === "es") return es_event_group_options_remove_success(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_remove_success(inputs)
	if (locale === "ja") return ja_event_group_options_remove_success(inputs)
	if (locale === "hi") return hi_event_group_options_remove_success(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_remove_success(inputs)
	return en_event_group_options_remove_success(inputs)
});